module.exports = __webpack_public_path__ + "img/Glass.18e8b647.jpg";